export default "__VITE_ASSET__12490482__"